// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor[data-v-6ed2cddf] {\n  position: relative;\n}\n.toolbar[data-v-6ed2cddf] {\n  border: 1px solid #ccc;\n}\n.text[data-v-6ed2cddf] {\n  border: 1px solid #ccc;\n}\n.editor_line[data-v-6ed2cddf] {\n  position: absolute;\n  bottom: 0;\n  left: 2;\n  z-index: 999999999999;\n  width: 100%;\n  height: 2px;\n  background: #ccc;\n  margin-top: 0px;\n  cursor: s-resize;\n}\n", ""]);
// Exports
module.exports = exports;
